import { Box, Container, Divider, Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
// import TermsSVG from '../src/static/images/page/terms/terms.svg';
import { getRandomStr } from '../src/helpers';
import EastRoundedIcon from '@mui/icons-material/EastRounded';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import getPageMetaTags from '../lib/meta/_getMetaTags';
import { dataConstants } from '../src/constants';
// import onPageInit from '../src/actions/onPageInit';

const Privacy = ({ toggleColorMode, themeMode }) => {
  const { asPath } = useRouter();
  // const [mounted, setMounted] = useState(false)

  // if (!mounted) {
  //   onPageInit(asPath);
  // }

  // useEffect(() => {
  //   setMounted(true)
  // }, [])

  const TermsOfUse = [
    {
      Introduction: [
        {
          heading: "Introduction",
          para: [
            { graph: "Knowtilus Technologies Pvt Ltd. ('us', 'we', or 'our') operates https://www.grufity.com website and Grufity Add-in for Microsoft ® Excel (collectively known as the 'Service')." },
            { graph: "We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from https://www.grufity.com" },
          ]
        },
      ],
    },
    {
      Introduction: [
        {
          heading: "Information Collection And Use",
          para: [
            {
              graph: "Knowtilus Technologies Pvt Ltd. uses the collected data for various purposes:",
              list: [
                { graph: "While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ('Personal Data'). Personally identifiable information may include, but is not limited to:" },
                { ul: "Email address" },
                { ul: "Cookies and Usage Data" },
              ]
            },
          ]
        },
      ],
      Terms: [
        {
          heading: "Types of Data Collected",
          para: [
            {
              graph: "Personal Data",
              list: [
                { graph: "While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you ('Personal Data'). Personally identifiable information may include, but is not limited to:" },
                { ul: "Email address" },
                { ul: "Cookies and Usage Data" },
              ]
            },
            {
              graph: "Usage Data",
              list: [
                {
                  graph: "We may also collect information how the Service is accessed and used('Usage Data').This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data."
                },
              ]
            },
            {
              graph: "Tracking & Cookies Data",
              list: [
                {
                  graph: "We use cookies and similar tracking technologies to track the activity on our Service and hold certain information."
                },
                { graph: "Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service." },
                { graph: "You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service." },
                { graph: "Examples of Cookies we use:" },
                { ul: "Session Cookies. We use Session Cookies to operate our Service." },
                { ul: "Preference Cookies. We use Preference Cookies to remember your preferences and various settings." },
                { ul: "Security Cookies. We use Security Cookies for security purposes." },
              ]
            },
          ],
        },
      ],
    },
    {
      Introduction: [
        {
          heading: "Use of Data",
          para: [
            {
              graph: "Knowtilus Technologies Pvt Ltd. uses the collected data for various purposes:",
              list: [
                { ul: "To provide and maintain the Service" },
                { ul: "To notify you about changes to our Service" },
                { ul: "To allow you to participate in interactive features of our Service when you choose to do so" },
                { ul: "To provide customer care and support" },
                { ul: "To provide analysis or valuable information so that we can improve the Service" },
                { ul: "To monitor the usage of the Service" },
                { ul: "To detect, prevent and address technical issues" },
              ]
            },
          ]
        },
      ],
    },
    {
      Introduction: [
        {
          heading: "Transfer Of Data",
          para: [
            {
              graph: "Your information, including Personal Data, may be transferred to — and maintained on — computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction. ",
            },
            {
              graph: "If you choose to provide information to us, please note that your data, including Personal Data, will be sent to multiple countries around the world which may or may not have the same privacy laws as your country of citizenship or residence. ",
            },
            {
              graph: "Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer. ",
            },
            {
              graph: "Knowtilus Technologies Pvt Ltd. will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information. ",
            },
          ]
        },
      ],
    },
    {
      Introduction: [
        {
          heading: "Disclosure Of Data",
          para: [
            {
              graph: "Legal Requirements"
            },
            {
              graph: "Knowtilus Technologies Pvt Ltd. may disclose your Personal Data in the good faith belief that such action is necessary to:",
              list: [
                { ul: "To comply with a legal obligation" },
                {
                  ul: "To protect and defend the rights or property of Knowtilus Technologies Pvt Ltd."
                },
                { ul: "To prevent or investigate possible wrongdoing in connection with the Service" },
                { ul: "To protect the personal safety of users of the Service or the public" },
                { ul: "To protect against legal liability" },
              ]
            },
          ]
        },
      ],
    },
    {
      Introduction: [
        {
          heading: "Security Of Data",
          para: [
            {
              graph: "The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security."
            },
          ]
        },
      ],
    },
    {
      Introduction: [
        {
          heading: "Service Providers",
          para: [
            {
              graph: "We may employ third party companies and individuals to facilitate our Service ('Service Providers'), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used.These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose"
            },
            {
              graph: "Analytics",
              list: [
                {
                  graph: "We may use third-party Service Providers to monitor and analyze the use of our Service."
                },
                { ul: "Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network." },
                {
                  ul: "You can opt-out of having made your activity on the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js, and dc.js) from sharing information with Google Analytics about visits activity."
                },
                { ul: "For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page: https://policies.google.com/privacy?hl=en" },
              ]
            },
          ]
        },
      ],
    },
    {
      Introduction: [
        {
          heading: "Links To Other Sites",
          para: [
            {
              graph: "Our Service may contain links to other sites that are not operated by us. If you click on a third-party link, you will be directed to that third-party's site. We strongly advise you to review the Privacy Policy of every site you visit."
            },
            {
              graph: "We have no control over and assume no responsibility for the content, privacy policies or practices of any third-party sites or services."
            },
          ]
        },
      ],
    },
    {
      Introduction: [
        {
          heading: "Children's Privacy",
          para: [
            {
              graph: "Our Service does not address anyone under the age of 18 ('Children')."
            },
            {
              graph: "We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers."
            },
          ]
        },
      ],
    },
    {
      Introduction: [
        {
          heading: "Changes To This Privacy Policy",
          para: [
            {
              graph: "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page."
            },
            {
              graph: "We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the 'effective date' at the top of this Privacy Policy."
            },
            {
              graph: "You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page."
            },
          ]
        },
      ],
    },
  ]
  return (
    // <Layout
    //   toggleColorMode={toggleColorMode}
    //   themeMode={themeMode}
    // >
    //   <CssBaseline />
    <>
      <Container maxWidth="xl">
        {/* <Box sx={{ height: { xs: '30vh', sm: '30vh', md: '30vh' } }}> */}
        {/* <Grid container sx={{ height: '100%' }}>
            <Grid size={{ md: true, sm: 12 }}> */}
        <Box component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', flexDirection: 'column', mx: { sm: 0, md: 4 }, mt: 7 }} >
          <Typography variant="h1" gutterBottom sx={{ fontWeight: 500, fontSize: '1.5rem' }}>
            Privacy Policy
          </Typography>
          {/* <Typography variant="h6" gutterBottom sx={{ color: '#174c86', fontWeight: 400, letterSpacing: '1px' }}>
                  Learn more about how Grufity collects and uses data and your rights as a Grufity user.
                </Typography> */}
        </Box>
        {/* <</Grid>
            Grid item md sm={12} sx={{ width: '100%', position: 'relative', display: { sm: 'none', md: 'flex' }, alignItems: 'center' }}>
              {/* <TermsSVG style={{ position: 'absolute', }} /> 
              <Box component="div" sx={{ width: '60%', height: '72%', bgcolor: 'background.primary_light', m: 'auto' }} />
            </Grid>
          </Grid> */}
        {/* </Box> */}
      </Container>
      <Container maxWidth="lg" sx={{ my: 6 }}>
        {/* <Typography variant="h6" gutterBottom sx={{ fontSize: '1rem', fontWeight: 500 }}>
          Effective date: September 23, 2019
        </Typography> */}
        {/* <Divider /> */}
        {/* {TermsOfUse[0].Introduction.map(d => {
          return (
            <Box key={getRandomStr(3)}>
              <Typography variant="h6" gutterBottom sx={{ my: 2, color: 'text.link' }}>
                {d.heading}
              </Typography>
              {d.para && d.para.map(d => {
                let regex = /(\()([^)]+)(\))/g;
                return (
                  <Typography key={getRandomStr(3)} variant="subtitle2" gutterBottom component="div" sx={{ mb: 2, fontWeight: d.mainline ? 600 : 500, color: 'text.description' }}>
                    {(d.graph).replace(regex, "$1<mark>$2</mark>$3")}
                  </Typography>)
              }
              )}
            </Box>
          )
        })} */}
        {TermsOfUse.map((d, i) => {
          return (
            <>
              {TermsOfUse[i]?.Introduction?.map(d => {
                return (
                  <Box key={getRandomStr(3)}>
                    <Typography variant="h6" gutterBottom sx={{ mt: 2, color: 'text.link' }}>
                      {d.heading}
                    </Typography>
                    {d.para && d.para.map(d => {
                      // let regex = /(\()([^)]+)(\))/g;
                      // console.log(str.replace(regex, "$1<mark>$2</mark>$3"));
                      return (
                        <>
                          <Typography key={getRandomStr(3)} variant="subtitle2" gutterBottom component="div" sx={{ mt: 2, fontWeight: d.mainline ? 600 : 500, color: 'text.description' }}>
                            {/* {(d.graph).replace(regex, "$1<mark>$2</mark>$3")} */}
                            {(d.graph)}
                          </Typography>
                          {d?.list && d?.list.map(d =>
                            <List key={getRandomStr(3)} dense={true} sx={{ mx: { sm: 0.5, md: 2 } }}>
                              {d.graph ?
                                <ListItem>
                                  <ListItemText
                                    sx={{ fontSize: '.87rem', color: 'text.very_light_desc' }}
                                    primary={d.graph}
                                  />
                                </ListItem> :
                                <ListItem>
                                  <ListItemIcon>
                                    <EastRoundedIcon sx={{ fontSize: '1.1rem', color: 'text.link' }} />
                                  </ListItemIcon>
                                  <ListItemText
                                    sx={{ fontSize: '.87rem', color: 'text.very_light_desc' }}
                                    primary={d.ul}
                                  />
                                </ListItem>}
                            </List>

                          )}
                        </>
                      )
                    }
                    )}
                  </Box>
                )
              })
              }
              {TermsOfUse[i]?.Terms?.map((d, e) => {
                return (
                  <>
                    <Typography key={getRandomStr(3)} variant="h6" gutterBottom sx={{ mt: 2, color: 'text.link' }}>
                      {e + 1}. {d.heading}
                    </Typography>
                    {d.para && d.para.map((d, i) => {
                      return (
                        <Box sx={{ mt: 3 }} key={getRandomStr(3)}>
                          <Box sx={{ display: 'flex' }} >
                            <Typography variant="subtitle2" component="div" sx={{ color: 'text.link', mx: 2 }}>
                              {e + 1}.{i + 1}
                            </Typography>
                            <Typography variant="subtitle2" component="div" sx={{ fontWeight: d.mainline ? 600 : 500, color: 'text.description' }}>
                              {/* {(d.graph).replace(regex, "$1<mark>$2</mark>$3")} */}
                              {(d.graph)}
                            </Typography>
                          </Box>
                          {d?.list && d?.list.map(d =>
                            <List key={getRandomStr(3)} dense={true} sx={{ mx: { sm: 0.5, md: 2 } }}>
                              {d.graph ?
                                <ListItem>
                                  <ListItemText
                                    sx={{ fontSize: '.87rem', color: 'text.very_light_desc' }}
                                    primary={d.graph}
                                  />
                                </ListItem> :
                                <ListItem>
                                  <ListItemIcon>
                                    <EastRoundedIcon sx={{ fontSize: '1.1rem', color: 'text.link' }} />
                                  </ListItemIcon>
                                  <ListItemText
                                    sx={{ fontSize: '.87rem', color: 'text.very_light_desc' }}
                                    primary={d.ul}
                                  />
                                </ListItem>}
                            </List>

                          )}
                        </Box>
                      )
                    }
                    )}
                    {d.list && d.list.map(d =>
                      <List key={getRandomStr(3)} dense={true} sx={{ mx: { sm: 0.5, md: 2 } }}>
                        {d.graph ?
                          <ListItem>
                            <ListItemText
                              sx={{ fontSize: '.87rem', color: 'text.very_light_desc' }}
                              primary={d.graph}
                            />
                          </ListItem> :
                          <ListItem>
                            <ListItemIcon>
                              <EastRoundedIcon sx={{ fontSize: '1.1rem', color: 'text.link' }} />
                            </ListItemIcon>
                            <ListItemText
                              primary={d.ul}
                            />
                          </ListItem>}
                      </List>

                    )}
                  </>
                )
              })
              }
            </>
          )
        })}
        <Box sx={{
          '& a': {
            textDecoration: 'none',
            color: 'text.link'
          },
          '& a:hover': {
            textDecoration: 'underline',
          }
        }}>
          <Typography variant="h6" gutterBottom sx={{ mt: 2, color: 'text.link' }}>
            Contact Us
          </Typography>
          <Typography key={getRandomStr(3)} variant="h6" gutterBottom sx={{ mt: 2, color: 'text.link' }}>
            If you have any questions about this Privacy Policy, please contact us:
          </Typography>
          <ListItem>
            <ListItemIcon>
              <EastRoundedIcon sx={{ fontSize: '1.1rem', color: 'text.link' }} />
            </ListItemIcon>
            <ListItemText
              primary={<>By email: <a href="mailto:contact@grufity.com?subject=Regarding Your Privacy Policy.">contact@grufity.com</a></>}
            />
          </ListItem>
        </Box>
        <Divider sx={{ mt: 4 }} />
        <Typography variant="h6" gutterBottom color="text.secondary" sx={{ fontSize: '.875rem', fontWeight: 500, mt: 1 }}>
          Effective date: September 23, 2019
        </Typography>
      </Container>
    </>
    // </Layout>
  )
}

export async function getStaticProps({ tabCode = "ABOUT", ticker = "" }) {

  const meta_tags = (await getPageMetaTags('/privacy', false)) || {}
  const { getMetaTags } = meta_tags || {}
  return {
    props: {
      meta_tags: getMetaTags?.tags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.DEFAULT_HOURS,
    // notFound: !ticker ? true : false,
  }
}
export default Privacy
